import copy from 'copy-to-clipboard';
import React, {useState, useEffect} from "react";
import {ACTION_FAVOURITE_PRODUCTS, ON_FAVOURITE_REMOVED} from "../../globals";
import axios from 'axios';
import Loading from "../../icons/Loading";
import getFavItems from "../../favourites/utils/getFavItems";
import ProductTile from "../../product-category/components/ProductTile";
import getFavItemsOfUser from "../../favourites/utils/getFavItemsOfUser";

const FavouritesPage = (props) => {
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);

    const isSharedPage = () => {
        return props.shared && props.hash;
    };

    const loadProducts = () => {
        if (props.shared) {
            getFavItemsOfUser(props.shared, props.hash).then((ids) => {
                axios.post(ACTION_FAVOURITE_PRODUCTS, {ids}).then((response) => {
                    setProducts(response.data);
                    setLoading(false);
                });
            });
        } else {
            getFavItems().then((ids) => {
                axios.post(ACTION_FAVOURITE_PRODUCTS, {ids}).then((response) => {
                    setProducts(response.data);
                    setLoading(false);
                });
            });
        }
    };

    useEffect(() => {
        window.addEventListener(ON_FAVOURITE_REMOVED, loadProducts);
        loadProducts();

        return () => {
            window.removeEventListener(ON_FAVOURITE_REMOVED, loadProducts);
        };
    }, [props.shared, props.hash]);

    if (loading) {
        return <Loading/>;
    }

    return (
        <div className="product-index">
            <div className="container-">
                <div className="product-index__header product-index__header--between">
                    <h1 className="h3 product-index__breadcrumbs text-secondary">Favourites</h1>
                    {props.shareLink && (
                        <p>
                            <a
                                href={props.shareLink}
                                target={'_blank'}
                                className={'btn'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    copy(props.shareLink, {
                                        debug: true,
                                        message: 'Press #{key} to copy',
                                    });
                                }}
                            >
                                Copy share link
                            </a>
                        </p>
                    )}
                </div>
                {products.length > 0 && (
                    <div className="product-index__grid">
                        {products.map((product) => (
                            <ProductTile product={product} key={'p' + product.id} lockShare={isSharedPage()}/>
                        ))}
                    </div>
                )}
                {products.length === 0 && !loading && <p>You have no favourites currently.</p>}
            </div>
        </div>
    );
};

export default FavouritesPage;
